import React from "react";
import { Link } from "react-router-dom";

const Header = () => {

  // Close mobile menu after click
  const closeNavbar = () => {
    const navbar = document.getElementById("navbarMenu");
    if (navbar && navbar.classList.contains("show")) {
      new window.bootstrap.Collapse(navbar).hide();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
      <div className="container">

        {/* Logo */}
        <Link
          className="navbar-brand fw-bold text-primary"
          to="/"
          onClick={closeNavbar}
        >
          Dr Abhinav Singh (MS, MCh)
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="navbarMenu">
          <ul className="navbar-nav ms-auto align-items-lg-center">

            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={closeNavbar}>
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/about" onClick={closeNavbar}>
                About
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/treatments" onClick={closeNavbar}>
                Treatments
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/blogs" onClick={closeNavbar}>
                Blogs
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/feedback" onClick={closeNavbar}>
                Feedback
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/contact" onClick={closeNavbar}>
                Contact
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/login" onClick={closeNavbar}>
                Login
              </Link>
            </li>

            {/* Consultation Button */}
            <li className="nav-item">
              <Link
                className="btn btn-primary ms-lg-3 mt-2 mt-lg-0"
                to="/appointment"
                onClick={closeNavbar}
              >
                For Consultation
              </Link>
            </li>

          </ul>
        </div>

      </div>
    </nav>
  );
};

export default Header;